export default __webpack_public_path__ + "static/media/arrow-up.4b692d21.svg";